<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<h3>Cancel Subscription</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<p v-if="inTrial">This will cancel your free trial immediately.</p>
					<p v-if="!inTrial">This will cancel your subscription after your current paid period has finished. You will not recieve any further invoices.</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center">
					<button class="button-action button-action-delete" @click="cancel">Cancel Subscription</button>
				</div>
			</div>
		</div>
	</Modal>
</template>

<script>
import subscription from '../../lib/subscription'
import auth from '../../lib/auth'
import moment from 'moment'
import Modal from './../Modal.vue'

export default {
  components: {
		Modal
	},
	computed: {
		tenant() {
			return this.$store.getters['tenant/get']
		},
		inTrial() {
			if(this.tenant && this.tenant.trialEndDate) {
				const today = moment()
				const trialEndDate = moment(this.tenant.trialEndDate)

				return (trialEndDate.diff(today, 'days') > 0)
			}
			return false
		}
	},
	methods: {
		cancel() {
			this.$store.commit('app/setLoading', true)

			subscription.cancel()
			.then((tenant) => {
				this.$store.commit('tenant/set', tenant)

				if(this.inTrial) {
					auth.logout()
				} else {
					//force page to update and reload account
					location.reload()
				}
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Account/Cancel.vue